import { Violations } from '~/features/Inspection/Violations'

export function ViolationsPage() {
  return <Violations />
}
